import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  orderSummary: () => __(translations.orderDetailsTab.orderSummary, 'Order summary'),
};
